module.exports = __webpack_public_path__ + "img/päivälaavu_original.2bf42ece.jpg";